// Overlay de transição de tela: pinta IMEDIATAMENTE no clique (antes do
// trabalho pesado de montar a tela nova travar a main thread) e some quando o
// destino termina de montar. Sem isso, clicar num card do pipeline dava
// segundos de tela congelada sem nenhum feedback. DOM puro — sem lib.

const OVERLAY_ID = 'screen-transition-overlay';
const SAFETY_TIMEOUT_MS = 10000;

let safetyTimer = null;

const ensureStyles = () => {
  if (document.getElementById(`${OVERLAY_ID}-style`)) return;
  const style = document.createElement('style');
  style.id = `${OVERLAY_ID}-style`;
  style.textContent = `
    #${OVERLAY_ID} {
      position: fixed; inset: 0; z-index: 9998;
      display: flex; flex-direction: column; align-items: center;
      justify-content: center; gap: 12px;
      background: rgba(10, 14, 25, 0.55);
      backdrop-filter: blur(3px);
      opacity: 0; transition: opacity 0.15s ease;
      pointer-events: all;
    }
    #${OVERLAY_ID}.visible { opacity: 1; }
    #${OVERLAY_ID} .sto-spinner {
      width: 38px; height: 38px; border-radius: 9999px;
      border: 3px solid rgba(148, 163, 184, 0.25);
      border-top-color: #3b82f6;
      animation: sto-spin 0.7s linear infinite;
    }
    #${OVERLAY_ID} .sto-label {
      font-size: 13px; font-weight: 500; color: #cbd5e1;
    }
    @keyframes sto-spin { to { transform: rotate(360deg); } }
  `;
  document.head.appendChild(style);
};

export const hideScreenTransitionOverlay = () => {
  clearTimeout(safetyTimer);
  safetyTimer = null;
  const el = document.getElementById(OVERLAY_ID);
  if (!el) return;
  el.classList.remove('visible');
  setTimeout(() => el.remove(), 200);
};

export const showScreenTransitionOverlay = label => {
  ensureStyles();
  let el = document.getElementById(OVERLAY_ID);
  const wasVisible = Boolean(el && el.classList.contains('visible'));
  if (!el) {
    el = document.createElement('div');
    el.id = OVERLAY_ID;
    el.innerHTML =
      '<div class="sto-spinner"></div><span class="sto-label"></span>';
    document.body.appendChild(el);
  }
  // Já visível (ex.: clique no card mostrou "Abrindo negócio…" e o router
  // dispara de novo): mantém o rótulo específico, só re-arma o timer.
  if (!wasVisible) {
    el.querySelector('.sto-label').textContent = label || 'Carregando…';
  }
  // força reflow para a transição de opacity valer na primeira exibição
  el.getBoundingClientRect();
  el.classList.add('visible');

  clearTimeout(safetyTimer);
  // rede fora do ar / erro de navegação: nunca deixa o overlay preso na tela
  safetyTimer = setTimeout(hideScreenTransitionOverlay, SAFETY_TIMEOUT_MS);
};

// Garante 2 frames pintados antes de seguir — é o que faz o overlay APARECER
// antes de o mount pesado da próxima tela travar a main thread.
export const paintThen = () =>
  new Promise(resolve => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });
